import React from 'react';

export const NotificationToast = ({ notification, setNotification }) => {
    if (!notification.message) return null;
    return (
        <div className={`fixed bottom-6 right-6 px-6 py-3 rounded-lg shadow-xl text-white z-50 flex items-center gap-3 transition-all duration-300 transform translate-y-0 ${
            notification.type === 'error' ? 'bg-red-500' : notification.type === 'success' ? 'bg-green-500' : 'bg-slate-1000'
        }`}>
            <span className="text-sm font-medium">{notification.message}</span>
            <button onClick={() => setNotification({ message: '', type: '' })} className="opacity-80 hover:opacity-100">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
        </div>
    );
};